import { Component, HostBinding, Input, OnInit, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'app-circle-progress',
  templateUrl: './circle-progress.component.html',
  styleUrls: ['./circle-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class CircleProgressComponent implements OnInit {
  @Input() max: number = 100

  @HostBinding('style.--progress-bar-color')
  @Input()
  color: string
  @Input() label: string

  @HostBinding('style.--label-color')
  @Input()
  labelColor: string

  @HostBinding('style.--label-font-size')
  @Input()
  fontSize: string

  @HostBinding('style.--progress-value')
  progressValue: number

  _value: number = 0
  @Input()
  set value(v: number) {
    this._value = v
  }
  get value(): number {
    return this._value
  }

  constructor() {}

  ngOnInit(): void {
    this.progressValue = (this.value / this.max) * 100
  }
}
